module.exports = __webpack_public_path__ + "public/images/stands-bookmarks-on.f381ecb0b173b8b9149e6ed7f9bfca33.svg";